import { api } from '../../../lib/api'

export const ADD_MESSAGE_REQUEST = 'ADD_MESSAGE_REQUEST'
export const ADD_MESSAGE_SUCCESS = 'ADD_MESSAGE_SUCCESS'
export const ADD_MESSAGE_FAILED = 'ADD_MESSAGE_FAILED'

export const addMessage = function (fromId, toId, identifier, message, onComplete) {
  return function (dispatch) {
    dispatch({
      type: ADD_MESSAGE_REQUEST
    })
    api.addMessage(fromId, toId, identifier, message).then(addMessageResponse => {
      dispatch({
        type: ADD_MESSAGE_SUCCESS,
        payload: addMessageResponse
      })
      onComplete()
    }).catch(error => {
      dispatch({
        type: ADD_MESSAGE_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/message/add-message.js